<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <ng-container>
        <div style="padding: 15px; margin: 5px; width: -webkit-fill-available;">
            <div class="main-heading">
                <h1>Subscriber Email Dashboard</h1>
            </div>
            <div class="dropdown" style="margin: 10px 0;">
                <p-calendar [(ngModel)]="date" dateFormat="dd-mm-yy" [showIcon]="true" placeholder="Select Date"
                    (ngModelChange)="onDateChange($event)"></p-calendar>
            </div>
            <div *ngIf="subscriberMail" class="editor-content" style="margin-bottom: 10px;">
                <div *ngIf="!isEditing">
                    <div [innerHTML]="sanitizeHtml(subscriberMail)"></div>
                    <div class="send-mail-container">
                        <button class="btn btn-edit" (click)="enableEditing()">Edit</button>
                        <button class="btn btn-send" (click)="sendMail()">Send Mail</button>
                    </div>
                </div>

                <div *ngIf="isEditing">
                    <!-- <ckeditor [editor]="Editor" [ngModel]="editedMail" (ngModelChange)="onEditorChange($event)">
                    </ckeditor> -->
                    <div [formGroup]="form">
                        <div formControlName="html" [ngxSummernote]="config" [ngModel]="editedMail">
                        </div>
                    </div>
                    <div class="button-group">
                        <button class="btn btn-save" (click)="saveChanges()">Save</button>
                        <button class="btn btn-cancel" (click)="cancelEditing()">Cancel</button>
                        <!-- Send Mail button -->
                    </div>
                </div>
            </div>
            <!-- <div class="editor-content" style="margin-bottom: 10px;">
                <div [innerHTML]="sanitizeHtml(subscriberMail)"></div>
            </div> -->
            <!-- <div class="container-fluid">
                <div class="table-container" *ngIf="counts?.length > 0">
                    <div class="current-date-container" *ngIf="currentDate">
                        <p class="current-date">Date: {{ currentDate }}</p>
                    </div>
                    <h2 style="color: green;">Summary:</h2>
                    <table class="table table-bordered">
                        <tbody>
                            <tr *ngFor="let item of counts">
                                <td>{{ item.type }}</td>
                                <td>{{ item.count }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="table-container" *ngIf="approvedANDAData?.length > 0">
                    <h2>Approved ANDA:</h2>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th *ngFor="let header of approvedANDAHeaders">{{ header }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of approvedANDAData">
                                <td *ngFor="let header of approvedANDAHeaders">{{ row[header] }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="summary-container" *ngIf="approvedANDASummary?.length > 0" class="summary-container">
                    <h2>Approved ANDA:</h2>
                    <div class="editor-content" style="margin-bottom: 10px;"
                        *ngFor="let summary of approvedANDASummary">
                        <p [innerHTML]="sanitizeHtml(summary)"></p>
                    </div>
                </div>
                <div class="table-container" *ngIf="tentativeANDAData?.length > 0">
                    <h2>Tentative ANDA:</h2>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th *ngFor="let header of tentativeANDAHeaders">{{ header }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of tentativeANDAData">
                                <td *ngFor="let header of tentativeANDAHeaders">{{ row[header] }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="summary-container" *ngIf="tentativeANDASummary?.length > 0" class="summary-container">
                    <h2>Tentative ANDA:</h2>
                    <div class="editor-content" style="margin-bottom: 10px;"
                        *ngFor="let summary of tentativeANDASummary">
                        <p [innerHTML]="sanitizeHtml(summary)"></p>
                    </div>
                </div>
            </div> -->
        </div>
    </ng-container>
</div>